var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03076 1.03125L16.8477 16.8482",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99388 3.6777C1.75321 5.07857 1 6.92109 1 8.93953C1 13.3244 4.55465 16.8791 8.93953 16.8791C10.958 16.8791 12.8005 16.1259 14.2014 14.8852L13.1383 13.8221C12.0109 14.7925 10.5437 15.3791 8.93953 15.3791C5.38308 15.3791 2.5 12.496 2.5 8.93953C2.5 7.33535 3.08658 5.86817 4.05696 4.74078L2.99388 3.6777ZM14.9116 11.3528C15.2131 10.6075 15.3791 9.7929 15.3791 8.93953C15.3791 5.38308 12.496 2.5 8.93953 2.5C8.08617 2.5 7.27157 2.66599 6.52627 2.96745L5.39301 1.83419C6.46041 1.30037 7.6649 1 8.93953 1C13.3244 1 16.8791 4.55465 16.8791 8.93953C16.8791 10.2142 16.5787 11.4187 16.0449 12.4861L14.9116 11.3528Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOff);
export default __webpack_public_path__ + "static/media/circle-off.11d7f0e074fe487135ec255428384710.svg";
export { ForwardRef as ReactComponent };